import { forwardRef } from 'react'
import { FieldIcon } from 'apps/studio/components/shared/FieldIcon'
import { generateStyles } from 'apps/studio/components/pdfViewer/elements/PdfElement'
import { STATIC_TABLE_ROW_HEIGHT } from 'apps/studio/lib/utils/entities'

const ELEMENT_OVERLAY_TYPES = ['dataInput', 'pageElement', 'table', 'tableMove']

const resolveOverlay = ({
  type,
  data,
  positionDefault,
  stylesDefault,
}) => {
  const { tableLayout, tablePosition, entryData, element } = data
  const { column_header_height } = tableLayout?.styles || {}
  const { width: baseTableWidth = 0, height: baseTableHeight = 0 } = tableLayout?.position || {}
  const { hide_column_header, hide_table_title } = tableLayout?.styles || {}

  const tableHeight =
    baseTableHeight
    + (hide_column_header ? 0 : (column_header_height || STATIC_TABLE_ROW_HEIGHT))

  const tablePositionHeight =
    (tablePosition?.height || 0)
    + STATIC_TABLE_ROW_HEIGHT

  if (type === 'tableMove') {
    return {
      width: baseTableWidth,
      height: tableHeight,
      iconType: 'Static Table',
      label: 'Static Table',
    }
  }
  if (type === 'table') {
    return {
      width: tablePosition?.width ?? positionDefault.width,
      height: tablePositionHeight ?? positionDefault.height,
      iconType: 'Static Table',
      label: 'Static Table',
    }
  }
  const isPageElement = type === 'pageElement'
  return {
    width: isPageElement ? element.position.width : positionDefault.width,
    height: isPageElement ? element.position.height : positionDefault.height,
    styles: isPageElement
      ? element.styles
      : generateStyles({ position: positionDefault, style: stylesDefault }),
    iconType: isPageElement ? element.element_type : entryData.type,
    label: isPageElement ? element.label : `New ${entryData.type}`,
  }
}

export const ElementOverlay = forwardRef(
  ({ activeDraggable, positionDefault, stylesDefault, scaleFactor }, ref) => {
    const data = activeDraggable?.data?.current
    if (!data || !ELEMENT_OVERLAY_TYPES.includes(data.type)) return null

    const { width, height, styles, iconType, label } = resolveOverlay({
      type: data.type,
      data,
      positionDefault,
      stylesDefault,
    })

    return (
      <div
        className="page-element element--is-dragging"
        ref={ref}
        style={{
          ...styles,
          width: width * scaleFactor,
          height: height * scaleFactor,
          '--scale-factor': scaleFactor,
        }}
      >
        <div className="element--label workspace-element--label">
          <FieldIcon type={iconType} />
          <span className="element--label-name">{label}</span>
        </div>
      </div>
    )
  }
)
